import React from 'react';
import PropTypes from 'prop-types';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import DatePickerField from '../DatePicker/DatePickerField';

const FormDatePickerField = ({
  fullWidth,
  input,
  label,
  meta,
  minDate,
  readOnly,
  renderInput,
  required,
  sx,
  variant,
  testId,
}) => {
  const shouldShowError = !!meta.error && (meta.submitFailed || meta.modified || meta.touched);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePickerField
        desktopModeMediaQuery="@media (min-width: 900px)" // TODO: HB-952 discuss min-width
        error={shouldShowError}
        fullWidth={fullWidth}
        helperText={shouldShowError ? meta.error : ''}
        label={label}
        minDate={minDate}
        name={input.name}
        onChange={input.onChange}
        components={{
          RightArrowIcon: ArrowForwardIcon,
          LeftArrowIcon: ArrowBackIcon,
        }}
        readOnly={readOnly}
        renderInput={renderInput}
        required={required}
        sx={sx}
        variant={variant}
        value={input.value}
        views={['year', 'month', 'day']}
        testId={testId}
      />
    </LocalizationProvider>
  );
};
FormDatePickerField.propTypes = {
  fullWidth: PropTypes.bool,
  input: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }),
  label: PropTypes.string,
  meta: PropTypes.shape(),
  minDate: PropTypes.instanceOf(Date),
  readOnly: PropTypes.bool,
  renderInput: PropTypes.func,
  required: PropTypes.bool,
  sx: PropTypes.shape({}),
  testId: PropTypes.string,
  variant: PropTypes.string,
  value: PropTypes.instanceOf(Date),
};
export default FormDatePickerField;
